<template>
    <section v-if="checkPath()">
        <div class="modal" :class="{ 'open': isModalOpen }">
            <button class="toggleModal" @click="toggleModal()">

                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 44 44" fill="none">
                    <mask id="mask0_439_766" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="44"
                        height="44">
                        <rect width="44" height="44" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_439_766)">
                        <path
                            d="M10.2437 39.2563C9.52561 38.5383 9.16659 37.6751 9.16659 36.6667C9.16659 35.6584 9.52561 34.7952 10.2437 34.0772C10.9617 33.3591 11.8249 33.0001 12.8333 33.0001C13.8416 33.0001 14.7048 33.3591 15.4228 34.0772C16.1409 34.7952 16.4999 35.6584 16.4999 36.6667C16.4999 37.6751 16.1409 38.5383 15.4228 39.2563C14.7048 39.9744 13.8416 40.3334 12.8333 40.3334C11.8249 40.3334 10.9617 39.9744 10.2437 39.2563ZM28.577 39.2563C27.8589 38.5383 27.4999 37.6751 27.4999 36.6667C27.4999 35.6584 27.8589 34.7952 28.577 34.0772C29.2951 33.3591 30.1583 33.0001 31.1666 33.0001C32.1749 33.0001 33.0381 33.3591 33.7562 34.0772C34.4742 34.7952 34.8333 35.6584 34.8333 36.6667C34.8333 37.6751 34.4742 38.5383 33.7562 39.2563C33.0381 39.9744 32.1749 40.3334 31.1666 40.3334C30.1583 40.3334 29.2951 39.9744 28.577 39.2563ZM11.2749 11.0001L15.6749 20.1667H28.5083L33.5499 11.0001H11.2749ZM9.53325 7.33341H36.5749C37.2777 7.33341 37.8124 7.64661 38.1791 8.273C38.5458 8.89939 38.561 9.53341 38.2249 10.1751L31.7166 21.9084C31.3805 22.5195 30.9298 22.9931 30.3645 23.3292C29.7992 23.6654 29.1805 23.8334 28.5083 23.8334H14.8499L12.8333 27.5001H32.9999C33.5194 27.5001 33.9548 27.6758 34.3062 28.0272C34.6576 28.3786 34.8333 28.814 34.8333 29.3334C34.8333 29.8529 34.6576 30.2883 34.3062 30.6397C33.9548 30.9911 33.5194 31.1667 32.9999 31.1667H12.8333C11.4583 31.1667 10.4194 30.5633 9.71659 29.3563C9.01381 28.1494 8.98325 26.9501 9.62492 25.7584L12.0999 21.2667L5.49992 7.33341H3.66659C3.14714 7.33341 2.71172 7.15772 2.36034 6.80633C2.00895 6.45494 1.83325 6.01953 1.83325 5.50008C1.83325 4.98064 2.00895 4.54522 2.36034 4.19383C2.71172 3.84244 3.14714 3.66675 3.66659 3.66675H6.64575C6.98186 3.66675 7.3027 3.75841 7.60825 3.94175C7.91381 4.12508 8.14297 4.3848 8.29575 4.72091L9.53325 7.33341Z"
                            fill="#359F47" />
                    </g>
                </svg>

                <svg width="25" height="25" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_439_792" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="44"
                        height="44">
                        <rect width="44" height="44" transform="matrix(-1 0 0 1 44 0)" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_439_792)">
                        <path
                            d="M26.4917 22L13.0167 35.475C12.5584 35.9333 12.3369 36.468 12.3521 37.0791C12.3674 37.6902 12.6042 38.225 13.0625 38.6833C13.5209 39.1416 14.0556 39.3708 14.6667 39.3708C15.2778 39.3708 15.8125 39.1416 16.2709 38.6833L30.3875 24.6125C30.7542 24.2458 31.0292 23.8333 31.2125 23.375C31.3959 22.9166 31.4875 22.4583 31.4875 22C31.4875 21.5416 31.3959 21.0833 31.2125 20.625C31.0292 20.1666 30.7542 19.7541 30.3875 19.3875L16.2709 5.27079C15.8125 4.81246 15.2702 4.59093 14.6438 4.60621C14.0174 4.62149 13.475 4.85829 13.0167 5.31662C12.5584 5.77496 12.3292 6.30968 12.3292 6.92079C12.3292 7.5319 12.5584 8.06663 13.0167 8.52496L26.4917 22Z"
                            fill="#359F47" />
                    </g>
                </svg>

            </button>
            <div v-if="modalStep !== 2" class="header">
                <p>{{ headerTitles[modalStep] }}</p>
            </div>
            <!-- Carrito -->
                   
            <template v-if="modalStep === 0">
                <div class="tableHead">
                    <div>
                        <p>Nombre del producto</p>
                    </div>
                    <div>
                        <p>SKU</p>
                    </div>
                    <div>
                        <p>Cantidad</p>
                    </div>
                </div>
                <div class="scroller">
                    <div class="item" v-for="(item, index) in shopCart" :key="index">
                        <div :title="item.name">
                            <p class="name">
                                <span @click="deleteItem(index)" class="ico"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M4 7H20H4ZM16 7V4C16 3.73478 15.8946 3.48043 15.7071 3.29289C15.5196 3.10536 15.2652 3 15 3H9C8.73478 3 8.48043 3.10536 8.29289 3.29289C8.10536 3.48043 8 3.73478 8 4V7H16ZM18 20V7H6V20C6 20.2652 6.10536 20.5196 6.29289 20.7071C6.48043 20.8946 6.73478 21 7 21H17C17.2652 21 17.5196 20.8946 17.7071 20.7071C17.8946 20.5196 18 20.2652 18 20Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg></span> 
                                {{ item.name }} 
                                <span>{{ getVariants(item) }}</span>
                            </p>
                        </div>
                        <div>
                            <p>{{ item.sku ? item.sku : '' }}</p>
                        </div>
                        <div>
                            <p>{{ item.cantidad }}</p>
                        </div>
                    </div>
                     <button v-if="shopCart?.length>0" class=" deleteCart" @click="clearCart()">
                       Vaciar carrito
                    </button>
                </div>
                <div class="btnCont">
                    <button class="btn goBack mov" @click="closeModal()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <mask id="mask0_448_813" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_448_813)">
                                <path
                                    d="M8.00005 19C7.71672 19 7.47922 18.9042 7.28755 18.7125C7.09588 18.5209 7.00005 18.2834 7.00005 18C7.00005 17.7167 7.09588 17.4792 7.28755 17.2875C7.47922 17.0959 7.71672 17 8.00005 17H14.1C15.15 17 16.0625 16.6667 16.8375 16C17.6125 15.3334 18 14.5 18 13.5C18 12.5 17.6125 11.6667 16.8375 11C16.0625 10.3334 15.15 10 14.1 10H7.80005L9.70005 11.9C9.88338 12.0834 9.97505 12.3167 9.97505 12.6C9.97505 12.8834 9.88338 13.1167 9.70005 13.3C9.51672 13.4834 9.28338 13.575 9.00005 13.575C8.71672 13.575 8.48338 13.4834 8.30005 13.3L4.70005 9.70005C4.60005 9.60005 4.52922 9.49172 4.48755 9.37505C4.44588 9.25838 4.42505 9.13338 4.42505 9.00005C4.42505 8.86672 4.44588 8.74172 4.48755 8.62505C4.52922 8.50838 4.60005 8.40005 4.70005 8.30005L8.30005 4.70005C8.48338 4.51672 8.71672 4.42505 9.00005 4.42505C9.28338 4.42505 9.51672 4.51672 9.70005 4.70005C9.88338 4.88338 9.97505 5.11672 9.97505 5.40005C9.97505 5.68338 9.88338 5.91672 9.70005 6.10005L7.80005 8.00005H14.1C15.7167 8.00005 17.1042 8.52505 18.2625 9.57505C19.4209 10.625 20 11.9334 20 13.5C20 15.0667 19.4209 16.375 18.2625 17.425C17.1042 18.475 15.7167 19 14.1 19H8.00005Z"
                                    fill="#1D3D77" />
                            </g>
                        </svg>
                    </button>
                    
                    
                    <button v-if="shopCart?.length>0" class="btn Step1" @click="modalStep = 1">
                        <p>Continuar</p>
                    </button>
                </div>
            </template>
            <!-- Formulario -->
            <template v-if="modalStep === 1">
                <form @submit.prevent="createQuotation(
                    company,
                    name,
                    address,
                    zipcode,
                    city,
                    country,
                    phone,
                    email,
                    comments,
                    terms
                )" class="scroller">
                    <fieldset>
                        <label for="empresa">Empresa</label>
                        <input v-model="company" id="empresa" name="empresa" type="text" placeholder="Ej. IACOPMX">
                    </fieldset>
                    <fieldset>
                        <label for="nombreCompleto">Nombre completo *</label>
                        <input v-model="name" id="nombreCompleto" name="nombreCompleto" type="text" placeholder="Ej. Juan Pérez"
                            required>
                    </fieldset>
                    <fieldset>
                        <label for="direccion">Dirección *</label>
                        <input v-model="address" id="direccion" name="direccion" type="text"
                            placeholder="Ej. Adolfo López Mateos KM 5.5 SN" required>
                    </fieldset>
                    <fieldset>
                        <label for="codigoPostal">Código postal *</label>
                        <input v-model="zipcode" id="codigoPostal" name="codigoPostal" type="text" placeholder="Ej. 21360" required>
                    </fieldset>
                    <fieldset>
                        <label for="ciudad">Ciudad *</label>
                        <input v-model="city" id="ciudad" name="ciudad" type="text" placeholder="Ej. Mexicali" required>
                    </fieldset>
                    <fieldset>
                        <label for="pais">País *</label>
                        <input v-model="country" id="pais" name="pais" type="text" placeholder="Ej. México" required>
                    </fieldset>
                    <fieldset>
                        <label for="telefono">Teléfono *</label>
                        <input v-model="phone" id="telefono" name="telefono" type="tel" placeholder="Ej. 686 842 3032" required>
                    </fieldset>
                    <fieldset>
                        <label for="correo">Correo electrónico *</label>
                        <input v-model="email" id="correo" name="correo" type="email" placeholder="Ej. ventas@iacop.com.mx" required>
                    </fieldset>
                    <fieldset>
                        <label for="comentarios">Comentarios</label>
                        <textarea v-model="comments" id="comentarios" name="comentarios" rows="5"
                            placeholder="Escribe tu mensaje aquí"></textarea>
                    </fieldset>
                    <div class="terms">
                        <button @click="terms = !terms" type="button" class="box" id="box">
                            <div class="fill" v-if="terms"></div>
                        </button>
                        <label for="box">He leído y acepto el <a href="/aviso-de-privacidad">Aviso de Privacidad</a></label>
                    </div>
                
                <div class="btnCont">
                    <button type="button" class="btn goBack" @click="modalStep = 0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <mask id="mask0_448_813" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_448_813)">
                                <path
                                    d="M8.00005 19C7.71672 19 7.47922 18.9042 7.28755 18.7125C7.09588 18.5209 7.00005 18.2834 7.00005 18C7.00005 17.7167 7.09588 17.4792 7.28755 17.2875C7.47922 17.0959 7.71672 17 8.00005 17H14.1C15.15 17 16.0625 16.6667 16.8375 16C17.6125 15.3334 18 14.5 18 13.5C18 12.5 17.6125 11.6667 16.8375 11C16.0625 10.3334 15.15 10 14.1 10H7.80005L9.70005 11.9C9.88338 12.0834 9.97505 12.3167 9.97505 12.6C9.97505 12.8834 9.88338 13.1167 9.70005 13.3C9.51672 13.4834 9.28338 13.575 9.00005 13.575C8.71672 13.575 8.48338 13.4834 8.30005 13.3L4.70005 9.70005C4.60005 9.60005 4.52922 9.49172 4.48755 9.37505C4.44588 9.25838 4.42505 9.13338 4.42505 9.00005C4.42505 8.86672 4.44588 8.74172 4.48755 8.62505C4.52922 8.50838 4.60005 8.40005 4.70005 8.30005L8.30005 4.70005C8.48338 4.51672 8.71672 4.42505 9.00005 4.42505C9.28338 4.42505 9.51672 4.51672 9.70005 4.70005C9.88338 4.88338 9.97505 5.11672 9.97505 5.40005C9.97505 5.68338 9.88338 5.91672 9.70005 6.10005L7.80005 8.00005H14.1C15.7167 8.00005 17.1042 8.52505 18.2625 9.57505C19.4209 10.625 20 11.9334 20 13.5C20 15.0667 19.4209 16.375 18.2625 17.425C17.1042 18.475 15.7167 19 14.1 19H8.00005Z"
                                    fill="#1D3D77" />
                            </g>
                        </svg>
                    </button>
                    <button type="submit" class="btn Step2">
                        <p>Enviar</p>
                    </button>
                </div>
                </form>
            </template>
            <!-- Final -->
            <template v-if="modalStep === 2">
                <div class="middle">
                    <svg xmlns="http://www.w3.org/2000/svg" width="127" height="127" viewBox="0 0 127 127" fill="none">
                        <rect width="127" height="127" rx="63.5" fill="#359F47" />
                        <mask id="mask0_432_1451" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="22" y="22"
                            width="84" height="83">
                            <rect x="22.29" y="22.0305" width="82.9388" height="82.9388" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_432_1451)">
                            <path
                                d="M55.293 71.4481L83.0256 43.7155C84.12 42.6211 85.4159 42.074 86.9134 42.074C88.4109 42.074 89.7068 42.6211 90.8011 43.7155C91.8955 44.8098 92.4426 46.1057 92.4426 47.6032C92.4426 49.1007 91.8955 50.3967 90.8011 51.491L59.1807 83.1114C58.0864 84.2057 56.7905 84.7529 55.293 84.7529C53.7955 84.7529 52.4996 84.2057 51.4052 83.1114L36.7182 68.4243C35.6238 67.33 35.0767 66.0341 35.0767 64.5366C35.0767 63.0391 35.6238 61.7431 36.7182 60.6488C37.8125 59.5545 39.1084 59.0073 40.6059 59.0073C42.1034 59.0073 43.3993 59.5545 44.4937 60.6488L55.293 71.4481Z"
                                fill="white" />
                        </g>
                    </svg>
                    <p>Su solicitud se ha realizado con éxito. <br><br>
                        Nos pondremos en contacto con usted para procesar su pedido.</p>
                </div>
                <div class="btnCont">
                    <button class="btn Step3" @click="closeModal()">
                        <p>Cerrar</p>
                    </button>
                </div>
            </template>
        </div>
        <div class="backdrop" v-if="isModalOpen" @click="closeModal()"></div>

        <div v-if="regLoading" class="loaderView">
            <div>
                <div class="loaderSpinner"></div>
                <p class="process">{{ process }}</p>
            </div>
        </div>

        <Notificacion :tipo="toastType" :titulo="toastTitle" :text="toastSub" :state="toastState" />


    </section>
</template>

<script>
import Notificacion from '@/components/utils/notificacion.vue';
import { mapActions } from 'vuex';
export default {
    name: 'cartModal',
    components:{
        Notificacion
    },
    data() {
        return {
            isModalOpen: false,
            modalStep: 0,
            headerTitles: [
                'Mi carrito',
                'Completa el siguiente formulario',
            ],
            company: '',
            name:'',
            address:'',
            zipcode:'',
            city:'',
            country:'',
            phone:'',
            email:'',
            comments:'',
            terms: false,

            toastType: '',
            toastTitle: '',
            toastSub: '',
            toastState: false,

            regLoading: false,
            process: "",
        }
    },
    created(){
        this.$store.dispatch('cart/getCart');
    },
    computed:{
        shopCart(){
           const data = this.$store.getters['cart/data'];
            return data;
        }
    },
    methods: {
        ...mapActions('cart', ['removeItem', 'saveCart']),
        ...mapActions('main', ['addItem']),
        async createQuotation(company,
                    name,
                    address,
                    zipcode,
                    city,
                    country,
                    phone,
                    email,
                    comments,
                    terms
            ){

            if(!terms){
                this.setNoti(true, 'Error', '', 'Debe aceptar los Términos y Condiciones para continuar.')
                return
            }

            this.regLoading = true
            const response = await this.addItem({
                option: 'quotation', item: { 
                    company,
                    name,
                    address,
                    zipcode,
                    city,
                    country,
                    phone,
                    email,
                    comments,
                    items: this.shopCart.map(item=> {
                        return {
                            quantity: item.cantidad,
                            productId: item.id, 
                            sku: item.sku,
                            name: `${item.name} | ${this.getVariants(item)}`
                        }
                    })
                }
            })
            this.regLoading = false

            if (!response.success) {
                this.setNoti(true, 'Error', '', response.message)
                return
            }

            this.modalStep = 2
            this.reset()
            this.clearCart()
        },
        reset(){
            this.company=''
            this.name=''
            this.address=''
            this.zipcode=''
            this.city=''
            this.country=''
            this.phone=''
            this.email=''
            this.comments=''
            this.terms= false
        },

        setNoti(toastState, toastType, toastTitle, toastSub) {
            this.toastState = toastState
            this.toastType = toastType
            this.toastTitle = toastTitle
            this.toastSub = toastSub
            setTimeout(() => {
                this.clearToast();
            }, 2000);
        },

        clearToast() {
            this.toastState = false
        },

        getVariants(item){
            if(item.simpleProduct || !item?.variants) return ''
            if(Array.isArray(item.variants) && item.variants.length > 0){
                return item.variants.map(variant => variant.name).join(' | ')
            }
            return ''
        },
        deleteItem(index){
            const result = this.removeItem(index)
            return result
        },
        clearCart(){
            const result = this.saveCart([])
            return result
        },
        toggleModal() {
            if (this.isModalOpen) {
                this.closeModal();
            } else {
                this.isModalOpen = true;
            }
        },
        closeModal() {
            this.isModalOpen = false;
            this.modalStep = 0;
        },
        checkPath(){
            if(this.$route.name === 'Dashboard' || this.$route.name === 'autentificacion' || this.$route.name === 'login') return false
            return true
        }
    }
}


</script>

<style scoped>
.backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.171);
    z-index: 1000;
}

.modal {
    position: fixed;
    top: 0;
    right: -400px;
    background-color: white;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 100%;
    width: 400px;
    border-radius: 8px 0 0 8px;
    z-index: 1001;
    transition: all 300ms ease;
}

.modal.open {
    right: 0;
}

.toggleModal {
    position: absolute;
    top: 80%;
    left: -50px;
    width: 50px;
    height: 50px;
    background-color: #ffffff;
    border-radius: 8px 0 0 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    /* https://smoothshadows.com/#djEsMSwzLDAuMDksMTE2LDAsLTU1LCMwMzA3MTIsI2YzZjRmNiwjZmZmZmZmLDI%3D */
    box-shadow: -6px 0px 13px rgba(3, 7, 18, 0.03),
        -24px 0px 52px rgba(3, 7, 18, 0.06),
        -55px 0px 116px rgba(3, 7, 18, 0.09);

}

.toggleModal svg {
    width: 25px;
    height: 25px;
    transition: all 500ms ease;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
}

.modal.open .toggleModal svg:first-child {
    left: 150%;
}

.toggleModal svg:last-child {
    left: -150%;
}

.modal.open .toggleModal svg:last-child {
    left: 50%;
}

.header {
    display: flex;
    padding: 8px 5px;
    justify-content: center;
    align-items: center;
    gap: 5px;
    align-self: stretch;

    background: #F5F5F5;
}

.header p {
    color: var(--Blue, #1D3D77);
    text-align: center;
    font-family: "Open Sans";
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
}

.tableHead {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
    flex-shrink: 0;
    align-self: stretch;
}

.tableHead>div:first-child {
    width: 100%;
    justify-content: flex-start;
    min-width: 0;

}

.tableHead>div {
    display: flex;
    width: 115px;
    padding: 5px 5px;
    justify-content: center;
    align-items: center;
    gap: 5px;
    align-self: stretch;

    background: #E6E6E6;
    color: var(--ColorText, #4C4C4C);
    font-family: "Open Sans";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.item {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
    flex-shrink: 0;
    align-self: stretch;
    background: #FAFAFA;
}

.item>div:first-child {
    width: 100%;
    justify-content: flex-start;
    min-width: 0;


}

.item>div p {
    
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
}

.item>div {
    display: flex;
    width: 115px;
    padding: 5px 5px;
    justify-content: center;
    align-items: center;
    gap: 5px;
    align-self: stretch;

    color: var(--ColorText, #4C4C4C);
    font-family: "Open Sans";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    overflow: hidden;
    text-align: center;
}

.item>div p.name{
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 5px;
}
.item>div p.name span{
    font-weight: 200; 
    font-size: 10px;
}
.item>div p.name span svg{
    width: 24px;
    height: 24px;
    padding-left: 5px;
    cursor: pointer;
}
.scroller {
    display: flex;
    flex-direction: column;
    gap: 6px;
    overflow-y: auto;
    height: 100%;
}

fieldset {
    display: flex;
    padding: 0px;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    align-self: stretch;
}

fieldset label {
    color: var(--Blue, #1D3D77);
    text-align: center;
    font-family: "Open Sans";
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
}

fieldset input,
fieldset textarea {
    width: 100%;
    padding: 8px;
    border: 1px solid #E6E6E6;
    border-radius: 4px;
    font-family: "Open Sans";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.btnCont {
    display: flex;
    flex-direction: row;
    gap: 12px;
    margin-top: auto;
}

.btn {
    flex: 1;
    display: flex;
    padding: 16px;
    justify-content: center;
    align-items: center;
    gap: 5px;
    flex-shrink: 0;
    align-self: stretch;
    transition: all 300ms ease;
    height: 52px;
}

.btn p {
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-family: "Open Sans";
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    transition: all 300ms ease;

}
.deleteCart {
    margin-top: 20px;
    display: flex;
    padding: 10px;
    justify-content: center;
    align-items: center;
    gap: 5px;
    flex-shrink: 0;
    align-self: stretch;
    transition: all 300ms ease;
    height: 40px;

    border: 1px solid #c92323;
    color: var(--Blue, #c92323);
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-family: "Open Sans";
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    transition: all 300ms ease;
}
.btn.Step1 {
    border: 1px solid #1D3D77;
    color: var(--Blue, #1D3D77);
}

.btn.Step1:hover {
    background-color: #1D3D77;
    color: #fff;
}

.btn.Step2 {
    background-color: #1D3D77;
    color: #fff;
}

.btn.Step2:hover {
    background-color: #359F47;
    color: #fff;
}

.btn.Step3 {
    background-color: #359F47;
    color: #fff;
}

.btn.Step3:hover {
    background-color: #288330;
    color: #fff;
}

.btn.goBack {
    border: 1px solid #1D3D77;
    color: var(--Blue, #1D3D77);
    flex: 0;
    padding: 11px;
}

.btn.goBack svg {
    height: 25px;
    width: 25px;
}

.btn.goBack:hover {
    background-color: #1345a154;
    color: white;
}

.terms {
    display: flex;
    flex-direction: row;
    gap: 8px;
}

.terms label {
    font-family: "Open Sans";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.terms .box {
    width: 16px;
    height: 16px;
    background-color: #E6E6E6;
    border-radius: 3px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.terms .box .fill {
    width: 10px;
    height: 10px;
    background-color: #359F47;
    border-radius: 2px;

}

.terms label a {
    color: #359F47;
}

.middle {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 15px;
    height: 100%;
}

.middle p {
    color: var(--Blue, #1D3D77);
    text-align: center;
    font-family: "Open Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
}

.mov {
    display: none;
}

@media (max-width: 530px) {
    .modal {
        width: 100%;
        right: -100%;
        border-radius: 0;
    }

    .mov {
        display: flex;
    }

    .modal.open {
        right: 0;
    }

    .header p {
        font-size: 15px;
    }

    fieldset label {
        font-size: 15px;
    }

    fieldset input,
    fieldset textarea {
        font-size: 17px;
        padding: 17px;
    }
    .terms {
        align-items: center;
    }

    .terms label {
        font-size: 15px;
    }

    .terms .box {
        width: 24px;
        height: 24px;
    }
    .terms .box .fill {
        width: 14px;
        height: 14px;
    }

     .btn p {
        font-size: 15px;
    }
}
</style>